export default __webpack_public_path__ + "static/media/fb00509ebe5ea0ec.79971d8a6fd1808d03e32ac81271d0cb.svg";